module.exports = __webpack_public_path__ + "videos/merch__video_mobile.4feffdb.mp4";